let workerURL = require('./helpers/get-worker-url');
let bundleURL = require('./helpers/bundle-url');
let url = bundleURL.getBundleURL('4ZtNJ') + "editor.worker.c02d26cb.js";module.exports = workerURL(url, bundleURL.getOrigin(url), false);